import styled from 'styled-components';

var PortalNode = styled.div.withConfig({
  displayName: "PortalNode",
  componentId: "sc-gdlb3t-0"
})(["position:relative;z-index:100;"]);

export { PortalNode };
